export class VideoSingle {
  constructor(element) {
    this.container = element;
    this.video = this.container.querySelector('video');
    this.button = this.container.querySelector('button');

    if (!this.video || !this.button) return;

    this.isPlaying = false;
    this.isPaused = false;

    this.button.addEventListener('click', () => this.handleButtonClick());
    this.video.addEventListener('pause', () => this.handlePause());
    this.video.addEventListener('play', () => this.handlePlay());
  }

  handleButtonClick() {
    if (!this.isPlaying) {
      this.startVideo();
    } else if (this.isPaused) {
      this.resumeVideo();
    }
  }

  startVideo() {
    this.video.removeAttribute('muted');
    this.container.classList.add('is-playing');
    this.video.removeAttribute('loop');
    this.video.removeAttribute('autoplay');
    this.video.setAttribute('controls', '');
    this.video.currentTime = 0; // restart

    this.video.play().then(() => {
      this.video.volume = 1; // set volume after playback starts
    }).catch(err => {
      console.warn('Playback failed:', err);
    });

    this.isPlaying = true;
    this.isPaused = false;
  }

  resumeVideo() {
    this.video.setAttribute('controls', '');
    this.video.play();
    this.isPaused = false;
  }

  handlePause() {
    if (this.isPlaying) {
      this.container.classList.add('is-paused');
      this.video.removeAttribute('controls');
      this.isPaused = true;
    }
  }

  handlePlay() {
    this.container.classList.remove('is-paused');
  }
}